import { motion } from 'motion/react';
import { Info, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface BetaStockRestrictionNoticeProps {
  demoTicker: string;
  onDismiss: () => void;
}

export function BetaStockRestrictionNotice({
  demoTicker,
  onDismiss,
}: BetaStockRestrictionNoticeProps) {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: -6, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -4, scale: 0.98 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
      role="tooltip"
      aria-live="polite"
      className="absolute left-0 top-full z-50 mt-3 w-[min(100vw-2rem,22rem)]"
    >
      <div className="relative rounded-2xl border border-gray-200 bg-white px-4 py-3.5 shadow-lg shadow-gray-900/10">
        <div
          aria-hidden
          className="absolute -top-1.5 left-6 h-3 w-3 rotate-45 border-l border-t border-gray-200 bg-white"
        />

        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100">
            <Info className="h-4 w-4 text-gray-600" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="mb-1 flex items-start justify-between gap-2">
              <p className="text-sm font-medium text-gray-900">Private beta preview</p>
              <button
                type="button"
                onClick={onDismiss}
                className="rounded-md p-0.5 text-gray-400 transition-colors hover:text-gray-700"
                aria-label="Dismiss beta notice"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <p className="text-sm leading-relaxed text-gray-600">
              You&apos;re exploring a preview of Guidance Gap. During beta, stock coverage is
              limited to <span className="font-medium text-gray-800">{demoTicker}</span>. Request
              full access to analyze any ticker.
            </p>

            <div className="mt-3 flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={() => navigate('/request-access')}
                className="rounded-full bg-black px-3.5 py-1.5 text-xs font-medium text-white transition-colors hover:bg-gray-800"
              >
                Request Access
              </button>
              <button
                type="button"
                onClick={onDismiss}
                className="rounded-full px-3 py-1.5 text-xs font-medium text-gray-500 transition-colors hover:text-gray-800"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
